import React, { useState } from 'react';
import { Row, Col, Button, Select, Alert } from 'antd';
import { ReloadOutlined, DashboardOutlined, BugOutlined } from '@ant-design/icons';
import UserInfo from './UserInfo';
import GraficasFavoritasWidget from './GraficasFavoritasWidget';
import ContadoresWidget from './ContadoresWidget';
import UltimosSensoresWidget from './UltimosSensoresWidget';
import ConsumoEnergiaWidget from './ConsumoEnergiaWidget';
import GraficasPersonalizadasWidget from './GraficasPersonalizadasWidget';
import { 
  mockDashboardData, 
  mockDashboardDataEmpresa, 
  mockDashboardDataSuperAdmin, 
  mockDashboardDataEmpty 
} from '../../utils/mockData';

const { Option } = Select;

const DashboardDev = () => {
  const [selectedMock, setSelectedMock] = useState('admin');
  const [loading, setLoading] = useState(false);

  const mockDataOptions = {
    admin: mockDashboardData,
    empresa: mockDashboardDataEmpresa,
    superadmin: mockDashboardDataSuperAdmin,
    empty: mockDashboardDataEmpty
  };

  const currentData = mockDataOptions[selectedMock];

  const handleRefresh = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  };

  const handleToggleFavorite = (id, favorita) => {
    console.log('Toggle favorite:', id, favorita);
    // En desarrollo, solo loggeamos la acción
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <div className="dashboard-header__title">
          <DashboardOutlined />
          <h1>Dashboard - Modo Desarrollo</h1>
          <BugOutlined style={{ color: '#faad14' }} />
        </div>
        
        <div className="dashboard-header__controls">
          <Select
            value={selectedMock}
            onChange={setSelectedMock}
            style={{ width: 200, marginRight: 16 }}
          >
            <Option value="admin">Admin - Datos Completos</Option>
            <Option value="empresa">Empresa - Datos Limitados</Option>
            <Option value="superadmin">Super Admin - Todos los Datos</Option>
            <Option value="empty">Sin Datos</Option>
          </Select>
          
          <UserInfo 
            userInfo={currentData.userInfo} 
            lastUpdated={new Date().toISOString()} 
          />
          
          <Button
            type="primary"
            icon={<ReloadOutlined />}
            onClick={handleRefresh}
            loading={loading}
          >
            Actualizar
          </Button>
        </div>
      </div>

      <Alert
        message="Modo Desarrollo Activo"
        description="Estás viendo datos de prueba. Las gráficas personalizadas funcionan con datos simulados."
        type="info"
        showIcon
        closable
        style={{ marginBottom: 16 }}
      />

      <div className="dashboard-content">
        <Row gutter={[16, 16]}>
          {/* Fila principal: Gráficas personalizadas */}
          <Col xs={24}>
            <GraficasPersonalizadasWidget />
          </Col>

          {/* Fila superior: Gráficas favoritas */}
          <Col xs={24} xl={16}>
            <GraficasFavoritasWidget 
              graficas={currentData.graficasFavoritas}
              onToggleFavorite={handleToggleFavorite}
            />
          </Col>

          {/* Fila superior: Contadores */}
          <Col xs={24} xl={8}>
            <ContadoresWidget contadores={currentData.contadores} />
          </Col>

          {/* Fila inferior: Últimos sensores */}
          <Col xs={24} xl={12}>
            <UltimosSensoresWidget sensores={currentData.ultimosSensores} />
          </Col>

          {/* Fila inferior: Consumo de energía */}
          <Col xs={24} xl={12}>
            <ConsumoEnergiaWidget consumoEnergia={currentData.consumoEnergia} />
          </Col>
        </Row>
      </div>

      {/* Información adicional */}
      <div className="dashboard-footer">
        <div className="dashboard-footer__info">
          <span>
            Modo Desarrollo • Datos simulados • Última actualización: {new Date().toLocaleString('es-ES')}
          </span>
        </div>
      </div>
    </div>
  );
};

export default DashboardDev;